import { useTranslate } from '@repo/shared/hooks'
import { Col, Typography } from '@repo/ui/components'
import { SquareTokenResponsiveImage } from './square-token-responsive-image'

export const SquareTokenSellSection = () => {
  const { t } = useTranslate()

  return (
    <section id='sell' className='py-5xl sm:py-8xl mb-[250px] sm:mb-[300px]'>
      <Col className='gap-3xl'>
        <Typography
          variant='h2'
          size='xl'
          weight='bold'
          className='text-center text-neutral-main'
        >
          {t('square_token_sell_title')}
        </Typography>

        <Typography
          variant='p'
          size='md'
          className='text-center text-neutral-main'
        >
          {t('square_token_sell_desc')}
        </Typography>

        <SquareTokenResponsiveImage />
      </Col>
    </section>
  )
}
